import { render } from "./Folder.vue?vue&type=template&id=43eceb98&scoped=true"
import script from "./Folder.vue?vue&type=script&lang=ts"
export * from "./Folder.vue?vue&type=script&lang=ts"

import "./Folder.vue?vue&type=style&index=0&id=43eceb98&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-43eceb98"

export default script